import React, { useCallback, useEffect } from 'react'
import { Button, Form, Space, Spin, Typography } from 'antd'

import { FormInput } from '../../../common/components/sections'
import {
  StyledPageActions,
  StyledPageHeader,
} from '../../../common/components/styled'
import { showErrorNotification } from '../../../common/helpers'
import { useDocumentTitle, useFormDirty } from '../../../common/hooks'

import { useEmailLoginMutation } from '../../hooks'
import { StyledLoginPanel } from '../styled'

const EmailLoginPage = () => {
  useDocumentTitle('Login')
  const [form] = Form.useForm()
  const { isDirty, setToDirty } = useFormDirty(form)

  const [loginWithEmail, { isLoading, error }] = useEmailLoginMutation()

  const handleLogin = useCallback(
    ({ email, code }) => loginWithEmail(email, code),
    [loginWithEmail],
  )

  useEffect(() => {
    if (error) {
      showErrorNotification({
        title: 'Login with email failed',
        description: error,
      })
    }
  }, [error])

  return (
    <Spin spinning={isLoading}>
      <Form
        form={form}
        name="login-form"
        onFinish={handleLogin}
        autoComplete="off"
        onFieldsChange={setToDirty}
      >
        <StyledLoginPanel>
          <Typography.Title>Metadata - FoodStyles</Typography.Title>
          <FormInput
            name="email"
            label="Email Address"
            labelAbove
            placeholder="Email Address..."
            rules={[
              {
                required: true,
              },
            ]}
          />
          <FormInput
            name="code"
            label="Security Code"
            labelAbove
            placeholder="Security Code..."
            rules={[
              {
                required: true,
              },
            ]}
          />
          <StyledPageHeader>
            <StyledPageActions>
              <Space>
                <Button disabled={!isDirty} type="primary" htmlType="submit">
                  Login
                </Button>
              </Space>
            </StyledPageActions>
          </StyledPageHeader>
        </StyledLoginPanel>
      </Form>
    </Spin>
  )
}

export default EmailLoginPage
